import { StatesModule } from '@uirouter/angular';
import { RequestAccessSettingEditComponent } from '@fi-app/request-access-setting/request-access-setting-edit/request-access-setting-edit.component';
import { RequestAccessSettingService } from '@fi-app/request-access-setting/request-access-setting.service';
import { RoleService } from '../role/services/role.service';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

const RequestAccessSettingResolve_requestAccessSetting = [
    RequestAccessSettingService,
    RequestAccessSettingResolve_requestAccessSetting_resolveFunc,
];

export function RequestAccessSettingResolve_requestAccessSetting_resolveFunc(
    requestAccessSettingService: RequestAccessSettingService,
) {
    return requestAccessSettingService.getRequestAccessSetting();
}

const RequestAccessSettingResolve_allRoles = [RoleService, RequestAccessSettingResolve_allRoles_resolveFunc];

export function RequestAccessSettingResolve_allRoles_resolveFunc(roleService: RoleService) {
    return roleService.getLightWeightRoles();
}

const RequestAccessSettingResolve_pageTitle = [PageTitleService, RequestAccessSettingResolve_pageTitle_resolveFunc];

export function RequestAccessSettingResolve_pageTitle_resolveFunc(pageTitleService: PageTitleService) {
    return pageTitleService.setTitleByTextId('other_settings.request_access');
}

export const FiRequestAccessSettingStates: StatesModule = {
    states: [
        {
            name: FiStateNames.OtherSettings.RequestAccess,
            url: '/RequestAccess/Edit',
            views: {
                '@': {
                    component: RequestAccessSettingEditComponent,
                },
            },
            resolve: {
                requestAccessSetting: RequestAccessSettingResolve_requestAccessSetting,
                pageTitle: RequestAccessSettingResolve_pageTitle,
            },
        },
    ],
};
